var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-footer',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],staticClass:"px-0 mt-10",attrs:{"color":"transparent"}})}
var staticRenderFns = []

export { render, staticRenderFns }